export default "__VITE_ASSET__qDm2T67d__"